module.exports = __webpack_public_path__ + "img/colorhover.485f081b.gif";